import { useContext, useEffect, useState } from 'react';
import { AuthFormWrapper } from '../../components/Authentication/AuthFormWrapper';
import Logo from '../../assets/logo.svg';
import { Button } from '../../layouts/ui/Button';
import { Loginvalidator } from '../../utils/validator';
import InputRegister from '../../layouts/ui/InputRegister';
import { Loginapi } from '../../services/Authentication/LoginApi';
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { GetBrowser } from '../../utils/browserid';
import { DataProvider } from '../../store/ContextProvider';
import { useLocation, useNavigate } from 'react-router-dom';

export const Login = () => {
    const { BeURL, setIsAuth, setCurrentUser, showAlert, setLogin } = useContext(DataProvider);
    const [form, setForm] = useState({ email: "", password: "" });
    const [errors, setErrors] = useState({});
    const [submitted, setSubmitted] = useState(false);
    const [fingerPrintId, setFingerPrintId] = useState(null);
    const [browserName, setBrowserName] = useState(null);
    const [ipAddress, setIpAddress] = useState(null);
    const [loading,setLoading]=useState(false)
    const navigate = useNavigate()
    const location = useLocation();

    const id = location.state?.jobId;
    const status = location.state?.status


    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
        setErrors({ ...errors, [name]: Loginvalidator(name, value)});     
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitted(true);

        // Validate all fields
        const newErrors = {
            email: Loginvalidator("email", form.email),
            password: Loginvalidator("password", form.password)
        };
        setErrors(newErrors);

        // Check if form is valid
        const isValid = Object.values(newErrors).every(err => !err);
        if (!isValid) return;

        // Call login API
        setLoading(true)
        await Loginapi({
            form, BeURL, setIsAuth, setCurrentUser, fingerPrintId, browserName, ipAddress, setLoading, navigate, setLogin, showAlert
        });
    };

    useEffect(() => {
        const fetchDeviceData = async () => {
            const fp = await FingerprintJS.load();
            const result = await fp.get();
            setFingerPrintId(result.visitorId);

            const tempBrowserName = await GetBrowser();
            setBrowserName(tempBrowserName);

            // Uncomment if IP needed
            const ipResponse = await fetch("https://api.ipify.org?format=json");
            const ipData = await ipResponse.json();
            setIpAddress(ipData.ip);
        };

        fetchDeviceData();
    }, []);

    const handleSignUp = () => {
        navigate('/signup', { state: { jobId : id, status }})
    }

    return (
        <AuthFormWrapper>
            <div className="w-full max-w-md mx-auto md:py-8 lg:px-10 space-x-3 md:space-y-6">
                <div className='flex justify-center'>
                    <img src={Logo} alt='Logo' className="w-28 md:w-36" />
                </div>
                <div className="space-y-1 text-center">
                    <p className="text-lg md:text-2xl font-bold text-gray-700">Welcome back</p>
                    <p className=" text-lg md:text-xl text-gray-500 font-semibold text-center">Connecting talent & opportunity.</p>
                    <p className='text-center text-gray-500'>Log in to get started.</p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-4 mt-6 md:mt-10">
                    <InputRegister
                        label="Email"
                        mandatory
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        error={errors.email}
                        type="email"
                        placeholder="your email address"
                        className={`w-full border p-2 rounded ${submitted
                                ? errors.email
                                    ? "border-red-500"
                                    : "border-green-500"
                                : "border-gray-300"
                            }`}
                    />

                    <InputRegister
                        label="Password"
                        mandatory
                        name="password"
                        value={form.password}
                        onChange={handleChange}
                        error={errors.password}
                        type="password"
                        placeholder="your password"
                        className={`w-full border p-2 rounded ${submitted
                                ? errors.password
                                    ? "border-red-500"
                                    : "border-green-500"
                                : "border-gray-300"
                            }`}
                    />

                    <p
                        onClick={() => navigate('/forgotpassword')}
                        className='text-end underline text-[#2C25C4] font-semibold cursor-pointer'
                    >
                        Forgot password?
                    </p>

                    <div className='flex justify-center'>
                        <Button
                            type="submit"
                            variant="primary"
                            className="w-60 h-12 text-white bg-[#2C25C4]"
                        >
                            {loading ? "Login..." : "Login"}
                        </Button>
                    </div>

                    <div className='flex justify-center items-center gap-2 font-bold'>
                        <div className='w-full h-[2px] bg-gray-400'></div>
                        <p>or</p>
                        <div className='w-full h-[2px] bg-gray-400'></div>
                    </div>
                </form>

                {/* <div className='flex justify-center'>
                    <Button
                        variant="primary"
                        className="w-60 h-12 bg-white"
                        onClick={() => window.location.href = '/login'}
                    >
                        Continue with Google
                    </Button>
                </div> */}

                <div className='flex justify-center items-center gap-2'>
                    <p>Don’t have an account?</p>
                    <p className="font-semibold text-[#2C25C4] cursor-pointer" onClick={handleSignUp}>
                        Sign up
                    </p>
                </div>
            </div>
        </AuthFormWrapper>
    );
};


